import { _ as _taggedTemplateLiteralLoose } from './taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';

var _templateObject;
var OrangeCtaLarge = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 40px;\n\twidth: 100%;\n\tbackground: ", ";\n\tborder-radius: 8px;\n\n\ttext-transform: uppercase;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: ", ";\n\toutline: 0;\n\tborder: 0;\n\tpadding: 0;\n\tmargin: 0;\n"])), function (props) {
  return props.backgroundColor || '#ff6d38';
}, function (props) {
  return props.textColor || '#fff';
});

export { OrangeCtaLarge as O };
